<template>
    <div>
        <el-dialog align-center @close="closeDialog" :showClose="false" v-model="centerDialogVisible" title="收件地址" width="945px">
            <el-form ref="form" :model="addressForm" label-position="left" :rules="rules" label-width="100px">
                <el-form-item label="收件人" prop="receiveName">
                    <el-input placeholder="请输入收件人姓名" v-model="addressForm.receiveName"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="receiveMobile">
                    <el-input placeholder="请输入收件人手机号码" v-model="addressForm.receiveMobile"></el-input>
                </el-form-item>
                <el-form-item class="region" label="所在地区" prop="receiveArea">
                    <el-cascader popperClass="address" placeholder="请选择所在区域" v-model="addressForm.receiveArea"
                        :options="options" :props="prop" />
                </el-form-item>
                <el-form-item label="详细地址" prop="detailAddress">
                    <el-input v-model="addressForm.detailAddress" :rows="2" type="textarea" placeholder="请输入街道、小区、楼栋号等" />
                </el-form-item>
                <el-form-item class="def_addr" label="1" prop="defaultAddress">
                    <el-checkbox-group v-model="addressForm.defaultAddress">
                        <el-checkbox label="true" name="defaultAddress" size="large">设为默认地址</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <div class="bot_btn">
                <el-button @click="centerDialogVisible = false" color="#666">取消</el-button>
                <el-button @click="subAddress" style="margin-left: 16px;" color="#386AEA">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onBeforeMount, watch } from 'vue'
import { defineProps, defineEmits } from 'vue'
import { validateMobile } from '@/utils/common.js'
import { addAddress, updateAddress,getAddressLists } from '@/api/shop'
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { el } from 'element-plus/es/locale'
const emits = defineEmits(['close'])
const props = defineProps({
    Visible: {
        type: Boolean,
        default: false
    },
    formData: {
        type: Object,
        default: () => { }
    },

})
const options = ref([])
onBeforeMount(() => {
    // TODO 1.2接口
    // getAddressList()
})
const prop = {
    label: 'name',
    children: 'children'
}
//获取地址
const getAddressList = () => {
    getAddressLists().then(res => {
        let result = res.result.map(item => {
            return {
                id: item.provinceId,
                name: item.provinceName,
                value: item.provinceName,
                children: item.cityList.map(city => {
                    return {
                        id: city.cityId,
                        name: city.cityName,
                        value: city.cityName,
                        children: city.districtList.map(district => {
                            return {
                                id: district.districtId,
                                name: district.districtName,
                                value: district.districtName
                            }
                        })
                    }
                })
            }
        })
        options.value = result
    }).catch(err => { console.log(err); })
}
const centerDialogVisible = ref(false)
const form = ref(null)
centerDialogVisible.value = props.Visible
const addressForm = ref({
    receiveName: '',
    receiveMobile: '',
    receiveArea: [],
    detailAddress: '',
    defaultAddress: []
})
const validateAddressDetail =  (rule, value, callback) => {
    if (value === "") {
        callback(new Error('详细地址不能为空'))
    } else if (!/^.{1,100}$/.test(value)) {
        callback(new Error('详细地址最多100个字'))
    } else {
        callback()
    }
}
//表单校验规则
const rules = ref({
    receiveName: [{ required: true, message: '请填写收件人姓名', trigger: 'blur' }],
    receiveMobile: [{ required: true, message: '请填写收件人手机号', trigger: 'blur' }, { validator: validateMobile, trigger: 'blur' }],
    receiveArea: [{ required: true, message: '请选择所在地区', trigger: 'change' }],
    detailAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' } , { validator: validateAddressDetail, trigger: 'blur' }],
})
watch(() => props.Visible, (val) => {
    centerDialogVisible.value = val
})
watch(() => props.formData, (val) => {
    if (val&&JSON.stringify(val) !== '{}') {
        console.log(val);
        val.defaultAddress = val.defaultAddress?['true']:[]
        val.receiveArea = val.receiveArea.split(' ')
        addressForm.value = val
    }
}, { immediate: true })
const closeDialog = () => {
    form.value.resetFields()
    emits('close', '')
}
//添加地址
const subAddress = () => {
    console.log(addressForm.value);
    let params = { ...addressForm.value, defaultAddress: addressForm.value.defaultAddress[0]==='true' ? true : false, receiveArea: addressForm.value.receiveArea.join(' ') }
    form.value.validate((value) => {
        if (value) {
            console.log(JSON.stringify(props.formData));
            if (props.formData&&JSON.stringify(props.formData) !== '{}') {
                updateAddress(params).then((res) => {
                    if (res.code === 200) {
                        ElMessage({
                            message: res.message,
                            customClass: "custom-message1",
                        });
                        centerDialogVisible.value = false
                    }
                }).catch(err => { console.log(err); })
            } else {
                addAddress(params).then((res) => {
                    if (res.code === 200) {
                        ElMessage({
                            message: res.message,
                            customClass: "custom-message1",
                        });
                        centerDialogVisible.value = false
                    }
                }).catch(err => { console.log(err); })
            }
        }
    })
}

</script>

<style lang="scss" scoped>
::v-deep .el-form-item:not(.address, .sub) {
    width: 480px;
    align-items: center;
    margin-bottom: 16px;
}
/**多选框 */

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #666;
    opacity: 1;
}

::v-deep .el-checkbox__label {
    color: #666;
    opacity: 1 !important;
}

::v-deep .def_addr .el-form-item__label {
    color: #fff;
}

::v-deep .el-checkbox.el-checkbox--large .el-checkbox__label {
    font-size: 16px;
    font-weight: 400;
}

::v-deep .el-checkbox.el-checkbox--large .el-checkbox__inner {
    width: 24px;
    height: 24px;
    background-color: #fff;
    border: 0.5px solid #66666632;
}

::v-deep .is-checked.el-checkbox--large .el-checkbox__inner {
    border: 0.5px solid #386AEA;
    background-color: #386AEA;
}

::v-deep .el-checkbox__inner::after {
    width: 5px;
    height: 13px;
    left: 8px;
    top: 2px;
    border-bottom: 2px solid #fff;
    border-right: 2px solid #fff;
    border-radius: 1px;
}

/**多选框----- */
/**el-dialog -- -start */
::v-deep .region .is-focus .el-input__wrapper {
    box-shadow: 0 0 0 1px rgba(0, 178, 92, ) inset !important
}

::v-deep .el-input__wrapper {
    height: 64px;
    padding: 1px 24px;
    box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.2) inset !important;
    background: rgba(0, 0, 0, 0.05)
}

::v-deep .el-input__inner::placeholder {
    color: #000;
    // font-family: PingFang SC;
    font-size: 16px;
    opacity: 0.4;
    font-style: normal;
    font-weight: 400;
    line-height: 200%;
}
::v-deep .el-form-item.is-error .el-textarea__inner{
    box-shadow: 0 0 0 0.5px #E70A27 inset !important;
    padding: 16px 24px;
}
::v-deep .el-form-item .el-textarea__inner{
    padding: 16px 24px;
}
::v-deep .el-input__inner {
    color: #333!important;
}

::v-deep .el-form-item__error {
    color: #E70A27;
    line-height: 24px;
    padding-top: 0px;
    margin: 8px 0px 16px;
}

::v-deep .el-form-item.is-error {
    margin-bottom: 48px;
}

::v-deep .el-form-item {
    width: 660px !important;
    // margin: 0 auto;
    margin-left: 72px;
}

::v-deep .el-form-item__content {
    margin-left: 0px !important;
}

::v-deep .el-textarea__inner {
    height: 260px;
    background-color: rgba(0, 0, 0, 0.05);
    appearance: none;
    resize: none;
    box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.2) inset;
}

::v-deep .el-dialog__header {
    padding-top: 32px;
    padding-left: 24px;
    margin-left: 0px !important;
    color: #333;
    // font-family: PingFang SC;
    font-size: 24px;
    font-weight: 500;
}

::v-deep .el-cascader .el-input__wrapper {
    width: 560px;
}

::v-deep .el-dialog {
    // top: 50%;
    // transform: translateY(-50%);
    // margin: 20px auto;
    border-radius: 4px;
}
::v-deep .el-overlay-dialog {
    padding: 137px 0px;
}
.des_two_row {
    overflow: hidden;
    text-overflow: ellipsis;
    text-overflow: -webkit-ellipsis-lastline;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
}

::v-deep .el-dialog__title {
    color: #333;
    // font-family: PingFang SC;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

/**el-dialog --- end */
.bot_btn {
    width: 400px;
    margin-left: 50%;
    margin-top: 40px;
    margin-bottom: 10px;
    transform: translateX(-50%);

    ::v-deep .el-button {
        width: 192px;
        height: 64px;
        color: #FFF;
        // font-family: PingFang SC;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
}
::v-deep .el-input__suffix{
    color: #999;
}
</style>
<style>
.address li:not(.in-active-path) .el-icon{
    color: #999;
}
.address .el-cascader-node.in-active-path,
.address .el-cascader-node.is-active,
.address .el-cascader-node.is-selectable.in-checked-path {
    color: #386AEA;
}
</style>